import { HUBLESS_APP_AUTH_RESULT } from './globalState';
import { getOrThrow, has } from 'quartz/globalState/api';
export const getHublessAppAuthResult = () => {
  if (!has(HUBLESS_APP_AUTH_RESULT)) {
    throw new Error('Hubless app auth not initialized');
  }
  return getOrThrow(HUBLESS_APP_AUTH_RESULT);
};